import { render } from "./virtual-grid.vue?vue&type=template&id=88d9fb10&ts=true"
import script from "./virtual-grid.vue?vue&type=script&lang=ts"
export * from "./virtual-grid.vue?vue&type=script&lang=ts"

import "./virtual-grid.vue?vue&type=style&index=0&id=88d9fb10&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__